<template>
    <div>
        <v-progress-circular
            :value="countdown_progress"
            size="60"
            width="4"
            color="primary"
            class="mb-2"
        >
            {{ countdown }}
        </v-progress-circular>

        <div class="text-center">
            <slot
                name="text"
                :countdown="countdown"
            />
        </div>

        <v-btn
            class="mt-3"
            color="primary"
            @click="$emit('counter-end')"
        >
            <strong>{{ counterOverrideText || 'Reset Now' }}</strong>
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'Countdown',

    props: {
        color: {
            type: String,
            default: 'primary',
        },

        text: {
            type: String,
            default: 'Resetting form in {{ countdown }} seconds',
        },

        counterOverrideText: {
            type: String,
            default: '',
        },

        durationSeconds: {
            type: Number,
            default: 10,
        },

        startOnMount: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            countdown: this.durationSeconds,
            countdown_progress: 100,
            countdown_interval: null,
        };
    },

    methods: {
        startCountdown() {
            this.countdown_interval = setInterval(() => {
                this.countdown--;
                this.countdown_progress = (this.countdown / 10) * 100;
                if (this.countdown <= 0) {
                    this.$emit('counter-end')
                }
            }, 1000);
        },

        resetCountdown() {
            clearInterval(this.countdown_interval);
            this.countdown = this.durationSeconds;
            this.countdown_progress = 100;
            this.startCountdown();
        }
    },

    mounted() {
        if (this.startOnMount) {
            this.startCountdown();
        }
    },

    beforeDestroy() {
        if (this.countdown_interval) {
            clearInterval(this.countdown_interval);
        }
    }
}
</script>

<style lang="scss" scoped>
.v-btn--has-bg {
    color: rgba(255, 255, 255, 1);
}
</style>